import STooltip from './STooltip.vue';

export default STooltip;
